import React from 'react';
import Flags from 'country-flag-icons/react/1x1';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Text from '../Text';
import supportedLanguages from '../../translations/en/supportedLanguages.json';

const FlagIcon = ({ code }) => {
  const { convertIsoCode } = supportedLanguages;

  if (convertIsoCode[code] === undefined) {
    return (
      <IconWrapper>
        <Text>{code}</Text>
      </IconWrapper>
    );
  }
  const Flag = Flags[convertIsoCode[code].toUpperCase()];
  return <CountryCodeIcon>{Flag && <Flag />}</CountryCodeIcon>;
};

export default FlagIcon;

const IconWrapper = styled.div`
  overflow: hidden;
  border: 1px ${themeGet('colors.black.40')} solid;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  background: ${themeGet('colors.black.40')};
  align-items: center;
  align-self: center;
  display: flex;
  justify-content: center;
`;

const CountryCodeIcon = styled(IconWrapper)`
  &&& svg {
    width: 26px;
    border-radius: 50%;
  }
`;
